(function ($, Drupal, slick) {
  'use strict';

  Drupal.behaviors.carousels = {
    attach: function (context, settings) {
      const $footerCarousel = $('.js-teaser-list--adverts', context);
      const $carousels = $('.js-teaser-list--carousel, .js-teaser-list--adverts', context);
      const desktopSlidersToShow = 4;
      
      $footerCarousel.each(function (i) {
        const slideCount = $('.teaser-list__item', this).length;
        if (slideCount >= desktopSlidersToShow) {
          $(this).not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 4,
            arrows: false,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
              {
                breakpoint: 1100,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 750,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  arrows: false
                }
              }
            ]
          });
        }
      });

      $carousels.each(function (i) {
        const slideCount = $('.teaser-list__item', this).length;
        if (slideCount >= desktopSlidersToShow) {
          $(this).closest('.view-strip__carousel').addClass('view-strip__carousel--buttons');
          $(this).not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: desktopSlidersToShow,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            prevArrow: '<button type="button" class="slick__button slick__button--prev"></button>',
            nextArrow: '<button type="button" class="slick__button slick__button--next"></button>',
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 750,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  arrows: false
                }
              }
            ]
          });
        }
      });
    }
  };
})(window.jQuery, window.Drupal, window.slick);
